import { lazy } from 'react';

export const List = lazy(() => import('./list'));
export const Details = lazy(() => import('./details'));
export const InventoryDetails = lazy(() => import('./inventory-details'));
